module.exports = __webpack_public_path__ + "img/anquan.0905fc98.png";